// Aggiornamento dell'app (Capacitor) dall'app stessa.
//
// L'ultima versione la dice https://notflix.it/app/latest.json, pubblicato da
// release.yml insieme ad APK e IPA (il repository GitHub e' privato, quindi i suoi
// download dal telefono non funzionano). Su Android il plugin NotflixUpdate scarica
// l'APK e apre l'installatore, senza pagine di mezzo. Su iPhone un'app installata
// con Sideloadly/AltStore non puo' reinstallarsi da sola: si avvisa e si apre
// AltStore sulla sorgente pubblicata con ogni release.

import { Capacitor, registerPlugin } from '@capacitor/core';

export const NotflixUpdate = registerPlugin('NotflixUpdate');

const LATEST_URL = '/app/latest.json';
export const ALTSTORE_SOURCE = 'https://notflix.it/app/altstore.json';
const DISMISSED_KEY = 'notflix_update_dismissed';
export const UPDATE_CHECK_EVENT = 'notflix-update-check';

// Le app installate prima della 1.2.0 non hanno il plugin: non c'e' niente da fare.
export const hasUpdater = () =>
    Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('NotflixUpdate');

/** -1, 0, 1 confrontando "1.2.0" con "1.10.0" numero per numero. */
export function compareVersions(a, b) {
    const pa = String(a).replace(/^v/, '').split('.').map((n) => parseInt(n, 10) || 0);
    const pb = String(b).replace(/^v/, '').split('.').map((n) => parseInt(n, 10) || 0);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const d = (pa[i] || 0) - (pb[i] || 0);
        if (d !== 0) return d > 0 ? 1 : -1;
    }
    return 0;
}

/**
 * Cerca una versione piu' nuova di quella installata.
 * @returns {Promise<null | { current, latest, platform, apkUrl, notes }>}
 */
export async function checkForUpdate() {
    if (!hasUpdater()) return null;
    const info = await NotflixUpdate.getInfo();
    // L'app carica notflix.it, quindi e' una richiesta sullo stesso sito.
    const response = await fetch(LATEST_URL, { cache: 'no-store' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const release = await response.json();
    const latest = String(release.version || '').replace(/^v/, '');
    if (!latest || compareVersions(latest, info.versionName) <= 0) return null;
    return {
        current: info.versionName,
        latest,
        platform: info.platform,
        apkUrl: release.apkUrl || null,
        notes: release.notes || ''
    };
}

export const isDismissed = (version) => {
    try { return localStorage.getItem(DISMISSED_KEY) === version; } catch { return false; }
};

export const dismiss = (version) => {
    try { localStorage.setItem(DISMISSED_KEY, version); } catch { /* storage non disponibile */ }
};

/** Dal Profilo: "Controlla aggiornamenti" (mostra la finestra anche se rimandata). */
export const requestUpdateCheck = () => window.dispatchEvent(new Event(UPDATE_CHECK_EVENT));
